import React, { useEffect, useState } from "react";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { isValidEmail } from "../../utils/procurementForm.utils";
import { Autocomplete, TextField } from "@mui/material";
import { getEnterprises } from "../../../../services/api/bidderService";

export default function ProcurementBiddersSection({
  bidders,
  soumsErrors,
  soumsTouched,
  handleRemoveSoumissionnaire,
  handleSoumFieldChange,
  setSoumissionnaires,
  setSoumsTouched,
  handleAddSoumissionnaire,
  canAddSoumissionnaire,
  handleEmailChange,
  handleAddEmail,
  handleRemoveEmail,
}) {
  const [loading, setLoading] = useState(false);
  const [enterprises, setEnterprises] = useState([]);

  useEffect(() => {
    async function fetch() {
      try {
        setLoading(true);
        const result = await getEnterprises();
        if (result) {
          setEnterprises(result);
        }
      } catch (error) {
        console.error(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, []);

  return (
    <fieldset className="border border-gray-300 p-6 rounded">
      <legend className="block text-lg font-semibold bg-blue-100 px-4 py-2 leading-[1.6] rounded">Soumissionnaires</legend>

      {bidders.map((s, idx) => {
        const errorsHere = soumsErrors[idx] || {};
        const touchedHere = soumsTouched[idx] || {};

        return (
          <div
            key={idx}
            className="border rounded p-4 mt-4 bg-white relative"
            style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}
          >
            <div className="mt-0 flex flex-col gap-2">
              <>
                <div className="flex gap-4">
                  <label className="flex-[2]">
                    <Autocomplete
                      freeSolo
                      loading={loading}
                      loadingText="Chargement des entreprises en cours..."
                      options={enterprises}
                      getOptionLabel={enterprise => enterprise.name || ""}
                      value={enterprises?.find(e => e.name === s.nom) || null}
                      renderInput={params => <TextField {...params} label="Nom de l'entreprise" required />}
                      onChange={(event, enterprise) => {
                        if (enterprise) {
                          handleSoumFieldChange(idx, "nom", enterprise.name);
                          handleSoumFieldChange(idx, "numeroBCE", enterprise.enterpriseNumber);
                        }
                      }}
                      onInputChange={(event, newValue) => handleSoumFieldChange(idx, "nom", newValue)}
                      onBlur={() => {
                        let newTouched = [...soumsTouched];
                        newTouched[idx].nom = true;
                        setSoumsTouched(newTouched);
                      }}
                    />
                    {touchedHere.nom && errorsHere.nom && (
                      <div className="text-red-500 text-xs mt-1">
                        Nom requis
                      </div>
                    )}
                  </label>
                  <label className="flex-[1]">
                    <Autocomplete
                      freeSolo
                      loading={loading}
                      loadingText="Chargement des entreprises en cours..."
                      options={enterprises}
                      getOptionLabel={enterprise => enterprise.enterpriseNumber || ""}
                      value={enterprises?.find(e => e.enterpriseNumber === s.numeroBCE) || null}
                      renderInput={params => <TextField {...params} label=" Numéro d'entreprise (BCE)" required />}
                      onChange={(event, enterprise) => {
                        if (enterprise) {
                          handleSoumFieldChange(idx, "nom", enterprise.name);
                          handleSoumFieldChange(idx, "numeroBCE", enterprise.enterpriseNumber);
                        }
                      }}
                      onInputChange={(event, newValue) => handleSoumFieldChange(idx, "numeroBCE", newValue)}
                      onBlur={() => {
                        let newTouched = [...soumsTouched];
                        newTouched[idx].numeroBCE = true;
                        setSoumsTouched(newTouched);
                      }}
                    />
                    {touchedHere.numeroBCE && errorsHere.numeroBCE && (
                      <div className="text-red-500 text-xs mt-1">
                        Numéro d'entreprise requis
                      </div>
                    )}
                  </label>
                </div>

                <div className="flex gap-4">

                  <label className="flex-[0_0_150px]">
                    <span className="text-sm font-medium">
                      Civilité <span className="text-red-500">*</span>
                    </span>
                    <select
                      value={s.civility || ""}
                      onChange={e => handleSoumFieldChange(idx, "civility", e.target.value)}
                      onBlur={() => {
                        let newTouched = [...soumsTouched];
                        newTouched[idx].civility = true;
                        setSoumsTouched(newTouched);
                      }}
                      className={`mt-1 w-full border rounded px-3 py-2 ${touchedHere.civility && errorsHere.civility ? "border-red-500" : ""}`}
                    >
                      <option value="">Sélectionnez</option>
                      <option value="Monsieur">Monsieur</option>
                      <option value="Madame">Madame</option>
                    </select>
                    {touchedHere.civility && errorsHere.civility && (
                      <div className="text-red-500 text-xs mt-1">
                        Civilité requise
                      </div>
                    )}
                  </label>
                  <label className="flex-1">
                    <span className="text-sm font-medium">
                      Personne de contact <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="text"
                      value={s.personneContact}
                      onChange={e => handleSoumFieldChange(idx, "personneContact", e.target.value)}
                      onBlur={() => {
                        let newTouched = [...soumsTouched];
                        newTouched[idx].personneContact = true;
                        setSoumsTouched(newTouched);
                      }}
                      placeholder="Nom complet"
                      className={`mt-1 w-full border rounded px-3 py-2 ${touchedHere.personneContact && errorsHere.personneContact ? "border-red-500" : ""}`}
                    />
                    {touchedHere.personneContact && errorsHere.personneContact && (
                      <div className="text-red-500 text-xs mt-1">
                        Personne de contact requise
                      </div>
                    )}
                  </label>
                  <label className="flex-1">
                    <span className="text-sm font-medium">
                      Fonction <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="text"
                      value={s.job || ""}
                      onChange={e => handleSoumFieldChange(idx, "job", e.target.value)}
                      onBlur={() => {
                        let newTouched = [...soumsTouched];
                        newTouched[idx].job = true;
                        setSoumsTouched(newTouched);
                      }}
                      placeholder="Fonction (ex: Directeur, Chef de projet, ...)"
                      className={`mt-1 w-full border rounded px-3 py-2 ${touchedHere.job && errorsHere.job ? "border-red-500" : ""}`}
                    />
                    {touchedHere.job && errorsHere.job && (
                      <div className="text-red-500 text-xs mt-1">
                        Fonction requise
                      </div>
                    )}
                  </label>
                </div>

                <div className="flex flex-col gap-2 mt-2">
                  <span className="text-sm font-medium">
                    Emails <span className="text-red-500">*</span>
                  </span>
                  {s.emails.map((email, emailIdx) => (
                    <div key={emailIdx} className="flex items-center gap-2">
                      <input
                        type="email"
                        value={email}
                        onChange={e => handleEmailChange(idx, emailIdx, e.target.value)}
                        onBlur={() => {
                          let newTouched = [...soumsTouched];
                          if (!Array.isArray(newTouched[idx].emails)) {
                            newTouched[idx].emails = [];
                          }
                          newTouched[idx].emails[emailIdx] = true;
                          setSoumsTouched(newTouched);
                        }}
                        placeholder="exemple@email.be"
                        className={`mt-1 w-full border rounded px-3 py-2 ${touchedHere.emails
                          && touchedHere.emails[emailIdx]
                          && errorsHere.emails
                          && errorsHere.emails[emailIdx]
                          ? "border-red-500"
                          : ""
                          }`}
                      />
                      {s.emails.length > 1 && (
                        <button
                          type="button"
                          title="Supprimer cet email"
                          className="ml-1 px-2 py-1 rounded bg-red-50 text-red-500 hover:bg-red-100"
                          onClick={() => handleRemoveEmail(idx, emailIdx)}
                          tabIndex={-1}
                        >
                          &times;
                        </button>
                      )}
                    </div>
                  ))}
                  {touchedHere.emails
                    && errorsHere.emails
                    && errorsHere.emails.map
                    && errorsHere.emails.map((err, i) =>
                      err && touchedHere.emails[i]
                        ? (
                          <div
                            key={i}
                            className="text-red-500 text-xs mt-1"
                          >
                            Email valide requis
                          </div>
                        )
                        : null,
                    )}

                  <button
                    type="button"
                    onClick={() => handleAddEmail(idx)}
                    className="mt-1 px-3 py-1 bg-blue-50 text-blue-700 rounded hover:bg-blue-100 text-xs"
                    style={{
                      width: "fit-content",
                      opacity:
                        s.emails.length === 0
                          || !isValidEmail(s.emails[s.emails.length - 1])
                          ? 0.5
                          : 1,
                      pointerEvents:
                        s.emails.length === 0
                          || !isValidEmail(s.emails[s.emails.length - 1])
                          ? "none"
                          : "auto",
                    }}
                    tabIndex={-1}
                    disabled={
                      s.emails.length === 0
                      || !isValidEmail(s.emails[s.emails.length - 1])
                    }
                    title={
                      s.emails.length === 0 || !isValidEmail(s.emails[s.emails.length - 1])
                        ? "Vous devez encoder un email valide avant d'ajouter un autre"
                        : "Ajouter un email"
                    }
                  >
                    + Ajouter un email
                  </button>
                </div>
                <label>
                  <span className="text-sm font-medium">
                    N° de GSM / Téléphone
                  </span>
                  <PhoneInput
                    international
                    defaultCountry="BE"
                    value={s.telephone || ""}
                    onChange={(value) => {
                      let newSoums = [...bidders];
                      newSoums[idx].telephone = value;
                      setSoumissionnaires(newSoums);
                    }}
                    onBlur={() => {
                      let newTouched = [...soumsTouched];
                      newTouched[idx].telephone = true;
                      setSoumsTouched(newTouched);
                    }}
                    className="mt-1 w-full border rounded px-3 py-2"
                    limitMaxLength
                  />
                  {touchedHere.telephone && s.telephone && !isValidPhoneNumber(s.telephone) && (
                    <div className="text-red-500 text-xs mt-2">
                      Numéro non valide (ex : +32 476 12 34 56)
                    </div>
                  )}
                  {touchedHere.telephone && s.telephone && isValidPhoneNumber(s.telephone) && (
                    <div className="text-green-600 text-xs mt-2">
                      Numéro valide
                    </div>
                  )}
                </label>
              </>
            </div>
            {bidders.length > 1 && (
              <div className="flex justify-end mt-4">
                <button
                  onClick={() => handleRemoveSoumissionnaire(idx)}
                  className="bg-red-100 text-red-800"
                  style={{
                    border: "none",
                    padding: "4px 18px",
                    cursor: "pointer",
                    borderRadius: 15,
                    fontSize: 13,
                    fontWeight: "bold",
                  }}
                  type="button"
                >
                  Supprimer ce soumissionnaire
                </button>
              </div>
            )}
          </div>
        );
      })}

      {bidders.length < 3 && (
        <div
          className="mt-4 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded text-sm flex items-start gap-2"
          role="alert"
          aria-live="polite"
        >
          <span className="text-lg">⚠️</span>
          <div>
            <strong>Au moins 3 soumissionnaires sont requis.</strong><br />
            Veuillez ajouter suffisamment de soumissionnaires pour respecter cette exigence.
          </div>
        </div>
      )}

      <button
        type="button"
        onClick={handleAddSoumissionnaire}
        disabled={!canAddSoumissionnaire}
        style={{
          marginTop: 16,
          padding: "6px 12px",
          cursor: canAddSoumissionnaire ? "pointer" : "not-allowed",
          borderRadius: 4,
          backgroundColor: canAddSoumissionnaire ? "#3b82f6" : "#ccc",
          color: "white",
          border: "none",
          fontWeight: "bold",
          fontSize: 14,
          width: "auto",
        }}
        title={
          canAddSoumissionnaire
            ? "Ajouter un soumissionnaire"
            : "Complétez le soumissionnaire courant avant d'ajouter"
        }
      >
        + Ajouter un soumissionnaire
      </button>
    </fieldset>
  );
}
